<template>
  <section class="first-section-container">
    <div class="bg">
      <div class="first-section content-container">
        <div class="mobile-title-wrapper">
          
          <p class="title2">
            The Leading Omnichain Modular Storage
          </p>
          
          <p class="title3">
            ✨Lambda DA is a permanent Ethereum DA solution based on EIP-4844.<br>
            🚀The great innovation is about to be released.
          </p>
          
          

          <div class="btn-wrapper">
            <a class="lda-btn" href="https://lambdanetwork.medium.com/lambda-data-availability-lda-technical-solution-design-031eed6e724d" target="_blank">
              Explore LDA Solutions
            </a>
          </div>

          <a-alert style="margin:40px 0px" type="info" >
            <template #description>
              <p>
                Lambda Mainnet has upgraded to Lambda Chain; for unprocessed assets, email <b>support@lambdastorage.com</b> with your Lambda Mainnet 0x address.
              </p>
            </template> 
          </a-alert>
        
        </div>

        <div class="pc-title-wrapper">
          <p class="title2">
            The Leading Omnichain Modular Storage
          </p>
          
          <p class="title3">
            ✨Utilizing Ethereum Layer 2 blockchain and Permanent Storage services, <br><br>
            Lambda supports Rollups, DAPPs, and AI.
          </p>
          
          <div class="btn-wrapper">
            <a class="lda-btn" href="https://lambdanetwork.medium.com/lambda-data-availability-lda-technical-solution-design-031eed6e724d" target="_blank">
              Explore LDA Solutions
            </a>
          </div>



          <a-alert style="margin:40px 0px" type="info" >
            <template #description>
              <p>
                Lambda Mainnet has upgraded to Lambda Chain; for unprocessed assets, email <b>support@lambdastorage.com</b> with your Lambda Mainnet 0x address.
              </p>
            </template> 
          </a-alert>
          
        </div>

      </div>
    </div>
    </div>
    
  </section>
</template>

<script>

export default {
  components: {
    Anounce: () => import("@/components/Anounce.vue"),
    FlipCountdown: () => import("@/components/FlipCountdown.vue")
  },
  computed: {
    countDownEnd () {
      return new Date().getTime() > 1710338100 * 1000;
    },
    countDownDate () {
      const startTimeEpoch = 1710338100;
      const d = new Date(0);
      d.setUTCSeconds(startTimeEpoch);

      let month = d.getMonth() + 1;
      let day = d.getDate();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      let hour = d.getHours();
      if (hour < 10) hour = "0" + hour;

      let minute = d.getMinutes();
      if (minute < 10) minute = "0" + minute;

      let second = d.getSeconds();
      if (second < 10) second = "0" + second;
      const date = d.getFullYear() + "-" + month + "-" + day + " " + d.getHours() + ":" + minute + ":" + second;
      return date;
    }
  },
  methods: {
    tip () {
      this.$message.info('Coming soon');
    },
    toApp () {
      window.open('https://portal.lambda.im/');
    }

  },
};
</script>

<style lang="less" scoped>
.first-section-container {
  width: 100%;
  // height: 100vh;
  height: 800px;

  .bg {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

.lda-btn {
    width: 260px;
    height: 60px;
    display: block;
    outline: none;
    border: none;
    font-size: 18px;
    border-radius: 32px;
    text-align: center;
    color: #3f4ae1;
    line-height: 60px;
    font-weight: 300;
    font-weight: bold;
    background: #ffffff;
    cursor: pointer;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid #ffffff;
  }

  .lda-btn:hover {
    background: linear-gradient(180deg, #ffffff 10%, #b5c8ff 100%);
    color: #101778;
  }

@media (max-width: 500px) {
  .bg {
    background-image: url("../../../assets/home/BG.png");
  }

  .first-section {
    padding-top: 157px;

    .mobile-title-wrapper {
      display: block;

      .logo-warpper {
        margin-bottom: 1rem;

        img {
          max-width: 320px;
        }
      }

      .title2 {
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 28px;
      }
      .title3 {
        margin-top: 40px;
        text-align: center;
        margin-bottom: 0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;
      }

      .dencun {
        font-size:22px;
        margin-top: 30px;
        text-align: center;
        margin-bottom: 0;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;

        .info {
          font-size: 14px;
          line-height: 22px;
          margin:20px 0;
        }
      }


      .btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;

        button {
          cursor: pointer;
          color: #3f4ae1;
          outline: none;
          border: 1px solid transparent;
          width: 136px;
          height: 45px;
          background: #ffffff;
          border-radius: 34px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          line-height: 18px 
        }
        button:hover{
          transform: scale(1.04)
        }

        .bg-button {
          background: linear-gradient(108deg, #3f4ae1 100%, #6d43c6 100%);
          margin-right: 32px;
          border: 1px solid #ffffff;
          color: #ffffff
        }
      }

      .announce {
        text-align: center;
        margin-top: 100px;
      }
    }

    .pc-title-wrapper {
      display: none;
    }
  }
}

@media (min-width: 501px) {

  // .first-section-container {
  //   height: 854px;
  // }
  .bg {
    background-image: url("../../../assets/home/BG.png");
  }

  .first-section {
    position: relative;
    padding-top: 120px;

    .mobile-title-wrapper {
      display: none;
    }

    .pc-title-wrapper {
      display: block;

      .logo-warpper {
        margin-bottom: 1rem;

        img {
          max-width: 300px;
        }
      }

      .title2 {
        text-align: center;
        margin-bottom: 0;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
      }

      .title3 {
        margin-top: 40px;
        text-align: center;
        margin-bottom: 0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;
      }

      .btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;

        button {
          cursor: pointer;
          color: #3f4ae1;
          outline: none;
          border: 1px solid transparent;
          width: 136px;
          height: 45px;
          background: #ffffff;
          border-radius: 34px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          line-height: 18px 
        }
        button:hover{
          transform: scale(1.04)
        }

        .bg-button {
          background: linear-gradient(108deg, #3f4ae1 100%, #6d43c6 100%);
          margin-right: 32px;
          border: 1px solid #ffffff;
          color: #ffffff
        }
      }

      .dencun {
        font-size:42px;
        margin-top: 50px;
        text-align: center;
        margin-bottom: 0;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;

        .info {
          font-size: 24px;
          line-height: 28px;
          margin:30px 0;
        }
      }
      .announce {
        text-align: center;
        margin-top: 100px;
      }
    }
  }
}

@media (min-width: 1025px) and (max-width: 1443px) {
  .first-section {
    padding-top: 200px;
  }
}

@media (min-width: 700px) and (max-width: 1024px) {
  .bg {
    background-image: url("../../../assets/home/BG.png");
  }

  .first-section {
    padding-top: 150px;
  }
}

.flip-card{
  .flip-card__top {
    color: white !important;
  }
}


</style>
